module.exports = __webpack_public_path__ + "img/vn.9be72755.svg";